module.exports = __webpack_public_path__ + "img/制御工学1_6.3f8c11df.png";